<template>
  <div>
    <v-app-bar flat color="red-darken-3" class="pt-1">
      <v-app-bar-title>{{
        $t("leko_employees.shippings.label")
      }}</v-app-bar-title>
      <v-divider class="mx-5 hidden-md-and-down" inset vertical />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        color="grey-darken-4"
        variant="flat"
        class="ma-1"
        @click="exportToExcel"
      >
        {{ $t("leko_employees.shippings.export") }}
        <v-icon end>mdi-file-excel-outline</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  components: {},
  props: ["items"], // eslint-disable-line vue/require-prop-types
  data: () => ({}),
  methods: {
    exportData() {
      const items = [];
      this.$props.items.forEach((item) => {
        if (item.status === 2) {
          const itemObject = {
            ID: item.part_id.old_id,
            [this.$t("leko_employees.shippings.table.title")]:
              item.part_id.title,
            [this.$t("leko_employees.shippings.table.manufacturer_code")]:
              item.part_id.manufacturer_code,
            [this.$t("leko_employees.shippings.table.quality")]:
              item.part_id.quality.title,
            [this.$t("leko_employees.shippings.table.price")]:
              item.price.logistic_price,
            [this.$t("leko_employees.shippings.dimensions")]:
              `${item.part_id.dimensions.length}x${item.part_id.dimensions.width}x${item.part_id.dimensions.height} ${item.part_id.dimensions.unit}`,
            [this.$t("leko_employees.shippings.weight")]:
              `${item.part_id.weight.value} ${item.part_id.weight.unit}`,
            [this.$t("leko_employees.shippings.actions.tracking_number")]:
              item.tracking_number,
            [this.$t("leko_employees.shippings.name")]:
              `${item.buyer_details.name} ${item.buyer_details.surname}`,
            [this.$t("leko_employees.shippings.address")]:
              item.buyer_details.address,
            [this.$t("leko_employees.shippings.phone")]:
              item.buyer_details.phone,
            [this.$t("leko_employees.shippings.email")]:
              item.buyer_details.email,
          };
          items.push(itemObject);
        }
      });
      return items;
    },
    async exportToExcel() {
      const data = await this.exportData();

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Shippings");

      // Trigger download
      XLSX.writeFile(wb, "shippings.xlsx");
    },
  },
};
</script>
